export function buildInstagramFacebookLoginOptions(
  globalConfig,
  { isCommentsChannel }
) {
  const instagramConfigId = globalConfig?.instagramFacebookLoginConfigId;

  if (instagramConfigId) {
    return { config_id: instagramConfigId };
  }

  const scope = isCommentsChannel
    ? 'pages_manage_metadata,business_management,pages_show_list,pages_read_engagement,instagram_basic,instagram_manage_comments'
    : 'pages_manage_metadata,business_management,pages_messaging,instagram_basic,pages_show_list,pages_read_engagement,instagram_manage_messages';

  return { scope };
}
